exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav-pills[data-v-9b190190] {\r\n    font-size: 1.5em;\n}\r\n", ""]);

// exports
